import { SEGMENTS_FAMILY_NAME } from "app/components/widget/widget-utilities/segments/constants";
import { DEFAULT_DURATION_FOR_SEGMENTS, getShouldHideSegments } from "./utils";

export const BounceRate = {
    id: "SegmentsBounceRate",
    properties: {
        order: "7",
        dropdownOrder: 7,
        isHidden: getShouldHideSegments,
        hasWebSource: true,
        component: "CustomSegments",
        availabilityComponent: "CustomSegments",
        viewPermissions: {
            trafficSources: ["Desktop", "Total"],
        },
        title: "folderanalysis.tabs.bounce",
        group: "WebsiteAudienceOverview",
        family: SEGMENTS_FAMILY_NAME,
        dashboard: "true",
        state: "digitalsuite_segments-analysis-traffic",
        webSource: "Desktop",
        periodOverPeriodSupport: true,
        noCompare: true,
        defaultDuration: DEFAULT_DURATION_FOR_SEGMENTS,
    },
    widgets: {
        single: {
            defaultType: "SegmentsBounceRateGraph",
            SegmentsBounceRateGraph: {
                properties: {
                    options: {
                        showLegend: true,
                    },
                    periodOverPeriodSupport: true,
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Bounce Rate",
                    type: "long",
                    format: "percentagesign",
                    formatParameter: 0,
                    name: "BounceRate",
                    reversed: "False",
                    yAxisMax: 1,
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                },
            },
        },
        compare: {
            defaultType: "SegmentsBounceRateGraph",
            SegmentsBounceRateGraph: {
                properties: {},
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Bounce Rate",
                    type: "long",
                    format: "percentagesign",
                    formatParameter: 0,
                    name: "BounceRate",
                    reversed: "False",
                    yAxisMax: 1,
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                },
            },
        },
    },
};
